<div class="container-fluid">
	<div class="row row-cols-12">
		<h3>PTP Created Report</h3>
		<div class="col-2">
			<label class="form-label">Start Date</label>
			<input type="date" class="form-control" [(ngModel)]="startDate" />
		</div>
		<div class="col-2">
			<label class="form-label">End Date</label>
			<input type="date" class="form-control" [(ngModel)]="endDate" />
		</div>
		<div class="col-1">
			<br />
			<button
				class="btn btn-success"
				(click)="getPtpCreatedReport(startDate, endDate)"
				[disabled]="!startDate || !endDate"
			>
				Submit
			</button>
		</div>
		<div class="col-1">
			<br />
			<button
				class="btn btn-secondary"
				(click)="exportToExcel(startDate, endDate)"
				*ngIf="ptpCreatedList"
			>
				Export
			</button>
		</div>
	</div>
	<div class="row row-cols-12 mt-4" *ngIf="ptpCreatedList">
		<div class="col-12">
			<table #ptpTable class="table table-bordered table-hover ptp-table">
				<thead>
					<tr>
						<th>Created By</th>
						<th>Total PTP Created</th>
						<th>Total PTP Created Amount</th>
					</tr>
				</thead>
				<tbody>
					<tr *ngFor="let item of ptpCreatedList">
						<td>{{ item['created_by'] }}</td>
						<td>{{ item['P2PCreated'] }}</td>
						<td>{{ item['P2PCreatedAmount']?.toFixed(2) }}</td>
						
					</tr>
					<tr>
						<td style="font-weight: bold">Totals</td>
						<td>{{ ptpCreatedTotals['totalP2PCreated'] }}</td>
						<td>{{ ptpCreatedTotals['totalP2PCreatedAmount']?.toFixed(2) }}</td>
						
					</tr>
				</tbody>
			</table>
			<!-- <table
				#ptpDetailedTable
				style="display: none"
				class="table table-bordered table-hover ptp-table"
			>
				<thead>
					<tr>
						<th>Parent ID</th>
						<th>Payment Amount</th>
						<th>Payment Paid</th>
						<th>Payment Remaining</th>
						<th>Comments</th>
						<th>PTP Date</th>
						<th>Account Reference No</th>
						<th>Invalid</th>
						<th>Paid</th>
						<th>NLS Data</th>
						<th>Created At</th>
						<th>Created By</th>
						<th>Empty Parent</th>
						<th>Completed</th>
						<th>Loan Number</th>
						<th>Name</th>
						<th>Status</th>
						<th>Payment Type</th>
						<th>Adjusted</th>
						<th>Modified By</th>
						<th>Broken PTP</th>
						<th>Cancelled By</th>
						<th>Deleted By</th>
						<th>Applied By</th>
						<th>Cancelled At</th>
					</tr>
				</thead>
				<tbody>
					<tr *ngFor="let item of ptpDetailedList">
						<td>{{ item['parent_id'] }}</td>
						<td>{{ item['payment_amount']?.toFixed(2) }}</td>
						<td>{{ item['payment_paid']?.toFixed(2) }}</td>
						<td>{{ item['payment_remaining']?.toFixed(2) }}</td>
						<td>{{ item['comments'] }}</td>
						<td>{{ item['PtP_Date'] }}</td>
						<td>{{ item['acctrefno'] }}</td>
						<td>{{ item['Invalid'] }}</td>
						<td>{{ item['Paid'] }}</td>
						<td>{{ item['nls_data'] }}</td>
						<td>{{ item['created_at'] }}</td>
						<td>{{ item['created_by'] }}</td>
						<td>{{ item['emptyParent'] }}</td>
						<td>{{ item['completed'] }}</td>
						<td>{{ item['loan_number'] }}</td>
						<td>{{ item['name'] }}</td>
						<td>{{ item['status'] }}</td>
						<td>{{ item['payment_type'] }}</td>
						<td>{{ item['adjusted'] }}</td>
						<td>{{ item['modified_by'] }}</td>
						<td>{{ item['broken_ptp'] }}</td>
						<td>{{ item['cancelled_by'] }}</td>
						<td>{{ item['deleted_by'] }}</td>
						<td>{{ item['applied_by'] }}</td>
						<td>{{ item['cancelled_at'] }}</td>
					</tr>
				</tbody>
			</table>
			<table
				#ptpLoanGroup
				style="display: none"
				class="table table-bordered table-hover ptp-table"
			>
				<thead>
					<tr>
						<th>Payment Type</th>
						<th>Status</th>
						<th>Payment Amount</th>
						<th>Payment Paid</th>
						<th>Broken PTP</th>
						<th>Loan Number</th>
						<th>Loan Group</th>
						<th>Created By</th>
						<th>Created At</th>
						<th>PTP Date</th>
					</tr>
				</thead>
				<tbody>
					<tr *ngFor="let item of ptpLoanGroupList">
						<td>{{ item['payment_type'] }}</td>
						<td>{{ item['status'] }}</td>
						<td>{{ item['payment_amount']?.toFixed(2) }}</td>
						<td>{{ item['payment_paid']?.toFixed(2) }}</td>
						<td>{{ item['broken_ptp'] }}</td>
						<td>{{ item['loan_number'] }}</td>
						<td>{{ item['loan_group'] }}</td>
						<td>{{ item['created_by'] }}</td>
						<td>{{ item['created_at'] }}</td>
						<td>{{ item['PtP_Date'] }}</td>
					</tr>
				</tbody>
			</table> -->
		</div>
	</div>
</div>